export default "__VITE_PUBLIC_ASSET__df77d67d__"